'use client';

import React from 'react';
import ContactHero from './ContactHero';
import OfficeInformation from './OfficeInformation';
import ContactCTA from './ContactCTA';

const ContactInteractive: React.FC = () => {
  const heroData = {
    title: "Let\'s Discuss Your Legal Needs",
    subtitle: "Whether you're facing a probate dispute, personal injury claim, insurance issue, or contract matter, our experienced team is here to help. Reach out today for a free consultation.",
    responseTime: "We respond to all inquiries within 24 hours"
  };

  const officeInfo = {
    address: '100 Metcalfe St, Unite: 603',
    city: 'Ottawa',
    state: 'ON',
    zip: 'K1P 5M1',
    country: 'CANADA',
    phone: '+1-807-808-4167',
    fax: '+1-807-808-4269',
    officialEmail: 'zlubbert@lubbertassociatesllc.com',
    contactEmail: 'admin@lubbertassociatesllc.com',
    businessHours: [
      { day: 'Monday - Friday', hours: '9:00 AM - 6:00 PM' },
      { day: 'Saturday', hours: '10:00 AM - 2:00 PM' },
      { day: 'Sunday', hours: 'Closed' }
    ],
    parkingInfo: 'Complimentary parking available in the building garage. Visitor parking is located on Level P1. Please bring your parking ticket to our office for validation.',
    accessibilityInfo: 'Our office is fully wheelchair accessible with elevator access from the parking garage. We provide accommodations for clients with disabilities and can arrange for sign language interpreters with advance notice.'
  };

  return (
    <>
      <ContactHero {...heroData} />
      <div id="office-information">
        <OfficeInformation officeInfo={officeInfo} />
      </div>
      <ContactCTA />
    </>
  );
};

export default ContactInteractive;